import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import style from './index.scss';
import { getUserNameFromLC } from '../../../services/util';
import get from 'lodash/get';
import { NAMESPACE_AMLS, NAMESPACE_SMART_SCREENING } from '../appUtils';
import ProductsDropdown from './ProductsDropdown';
import NotificationsDropdown from './notifications/index';
import { getSelectedResources } from '../../../util/resourceManager';
const { crsResources, nsResources, tmResources } = getSelectedResources();

const StyledLink = styled(Link)`
  text-decoration: none;
  color: white;

  &:hover {
    color: white;
  }
`;

const Topbar = (props) => {
  // eslint-disable-line react/prefer-stateless-function
  const { appName, postLogout, menuCollaps, isLoading, authentication } = props;

  let breadcrumbs = window.location.pathname.slice(5).split('/');
  const attribute = authentication?.data?.find(
    ({ attributes }) => attributes?.length > 0
  );

  const productSourceIds =
    attribute && get(attribute, 'attributes.0.attributeValues', '');
  if (productSourceIds && productSourceIds.includes('17')) {
    breadcrumbs[0] = NAMESPACE_AMLS;
  }

  const mapBreadcrumbToLink = (breadcrumb) => {
    switch (breadcrumb.toLowerCase()) {
      case 'investigation':
        return (
          <StyledLink to={`/app/${appName}/investigation`}>
            {breadcrumb.toUpperCase()}
          </StyledLink>
        );
      case 'tm':
        return 'TM > ';
      case 'ns':
        return 'NS > ';
      case 'crs':
        return 'CRS > ';
      case 'trm':
        return 'FRAML';
      case 'dashboard':
        return ' > DASHBOARD';
      case 'riskview':
        return 'RISKVIEW';
      case NAMESPACE_SMART_SCREENING.toLowerCase():
        return `${NAMESPACE_SMART_SCREENING} > `;
      case 'str-report':
        return ' > STR';
      case 'ctr-report':
        return ' > CTR';
      default:
        return decodeURIComponent(
          ` > ${breadcrumb.split('___')[0].toUpperCase()}`
        );
    }
  };

  let nsRiskViewPermitted = false;
  let nsAlertsListingPermitted = false;

  let tmRiskViewPermitted = false;
  let tmAlertsListingPermitted = false;

  let crsDashboardPermitted = false;
  let crsListViewPermitted = false;

  let notificationsDropdownPermitted = false;

  if (
    authentication &&
    Array.isArray(authentication.data) &&
    authentication.data.length > 0
  ) {
    // list of Attributes
    const listOfAttributes = authentication.data;

    listOfAttributes.map((attribute) => {
      const scopes = attribute.details?.resource?.operations
        ? attribute.details.resource.operations
        : null;

      if (scopes) {
        if (scopes.includes(nsResources.APP_3_RESOURCE_UI_NS_ALERTS_LIST)) {
          nsAlertsListingPermitted = true;
        }

        if (scopes.includes(nsResources.APP_3_RESOURCE_UI_NS_RISK_VIEW)) {
          nsRiskViewPermitted = true;
        }

        if (
          scopes.includes(tmResources.APP_3_RESOURCE_UI_TM_ALERT_LIST_ALERTS)
        ) {
          tmAlertsListingPermitted = true;
        }

        if (
          scopes.includes(tmResources.APP_3_RESOURCE_UI_TM_ALERT_LIST_ANOMALIES)
        ) {
          tmAlertsListingPermitted = true;
        }

        if (scopes.includes(tmResources.APP_3_RESOURCE_UI_TM_DASHBOARD)) {
          tmRiskViewPermitted = true;
        }

        if (scopes.includes(crsResources.APP_3_RESOURCE_UI_CRS_DASHBOARD)) {
          crsDashboardPermitted = true;
        }

        if (scopes.includes(crsResources.APP_3_RESOURCE_UI_CRS_CUSTOMER_LIST)) {
          crsListViewPermitted = true;
        }

        if (
          scopes.includes(
            nsResources.APP_3_RESOURCE_UI_AMLS_COMMON_NOTIFICATIONS
          )
        ) {
          notificationsDropdownPermitted = true;
        }
      }
    });
  }

  // based on the resources above, allow NS or TM switching
  const allowedModules = [];
  if ((nsRiskViewPermitted || nsAlertsListingPermitted) && appName !== 'ns') {
    allowedModules.push('ns');
  }

  if ((tmRiskViewPermitted || tmAlertsListingPermitted) && appName !== 'tm') {
    allowedModules.push('tm');
  }

  if ((crsDashboardPermitted || crsListViewPermitted) && appName !== 'crs') {
    allowedModules.push('crs');
  }

  return (
    <div
      className={classnames(style.wrapper, menuCollaps ? style.collapsed : '')}>
      <div className={classnames('col-md-4')}>
        {appName === 'cm' ? (
          'FinCense Case Manager'
        ) : (
          <>Current location: {breadcrumbs.map(mapBreadcrumbToLink)}</>
        )}
      </div>
      <div className={classnames('col-md-4')}>
        <div
          style={{ display: 'flex' }}
          className={classnames('pull-right', style.userCtrl)}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center'
            }}>
            {notificationsDropdownPermitted && (
              <NotificationsDropdown {...props} />
            )}

            {getUserNameFromLC() && getUserNameFromLC() !== ''
              ? `Welcome, ${getUserNameFromLC()}`
              : ''}
          </div>
        </div>
      </div>
      <div className={classnames('col-md-2')}>
        <ProductsDropdown {...props} />
      </div>
      <div className={classnames('col-md-2')}>
        <div
          style={{ display: 'flex' }}
          className={classnames('pull-right', style.userCtrl)}>
          <button className="btn btn-link" onClick={postLogout}>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

Topbar.propTypes = {
  appName: PropTypes.string,
  pageName: PropTypes.string,
  postLogout: PropTypes.func.isRequired,
  authentication: PropTypes.object,
  menuCollaps: PropTypes.bool,
  isLoading: PropTypes.bool
};

export default Topbar;
